import { useBlocker } from "@tanstack/react-router";
import { useDialog } from "@/lib/Components/Dialog/Hooks/useDialog";
import { ConfirmCloseDialog } from "@/lib/Components/Dialog/ConfirmCloseDialog";

export function useUnsavedChangesBlocker(hasUnsavedChanges: boolean) {
  const { openAsPromise } = useDialog(ConfirmCloseDialog);

  useBlocker({
    disabled: !hasUnsavedChanges,
    enableBeforeUnload: hasUnsavedChanges,
    shouldBlockFn: async () => {
      return openAsPromise({}).then(
        () => false,
        () => true,
      );
    },
  });
}
